/* Modulo: Video Coverflow
   Deliberately does NOT use window.moduloLazyInit — that helper lives in the theme
   *extension* core, which injected page-builder sections never load. It does not
   exist at runtime; 61 files in this repo carry the dead branch. Roll our own. */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  /* Live query, never a load-time boolean: a shopper toggling reduced-motion
     mid-session must stop autoplay without a reload. */
  var RM = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function reduced() { return !!(RM && RM.matches); }

  function initSection(root) {
    if (!root || root.dataset.vcfReady === '1') return;
    root.dataset.vcfReady = '1';

    var track = root.querySelector('[data-vcf-track]');
    var stage = root.querySelector('[data-vcf-stage]');
    if (!track || !stage) return;

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-vcf-card]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-vcf-dot]'));
    var n = cards.length;
    if (n < 2) return;

    /* Looping needs a ring. Below 3 cards the wrap would place one card in two
       slots at once, so it degrades to a clamped deck. */
    var loop = root.dataset.vcfLoop === '1' && n >= 3;
    var autoplay = root.dataset.vcfAutoplay === '1';
    var active = parseInt(root.dataset.vcfActive, 10) || 0;
    var half = Math.floor(n / 2);

    function offsetOf(i) {
      var off = i - active;
      if (!loop) return off;
      if (off > half) off -= n;
      if (off < -half) off += n;
      return off;
    }

    function videoOf(card) { return card.querySelector('[data-vcf-video]'); }

    function pauseAllExcept(keep) {
      for (var i = 0; i < n; i++) {
        var v = videoOf(cards[i]);
        if (!v || v === keep) continue;
        try { v.pause(); v.muted = true; } catch (e) {}
        cards[i].classList.remove('is-playing', 'is-unmuted');
        syncCtrls(cards[i]);
      }
    }

    function syncCtrls(card) {
      var playing = card.classList.contains('is-playing');
      var unmuted = card.classList.contains('is-unmuted');
      var pb = card.querySelector('[data-vcf-play]');
      var mb = card.querySelector('[data-vcf-mute]');
      if (pb) pb.setAttribute('aria-pressed', playing ? 'true' : 'false');
      if (mb) mb.setAttribute('aria-pressed', unmuted ? 'true' : 'false');
    }

    function playCenter() {
      if (!autoplay || reduced()) return;
      var card = cards[active];
      var v = videoOf(card);
      if (!v) return;
      var p = v.play();
      /* A rejected play() (autoplay policy, no user gesture yet) must not leave the
         button claiming the clip is playing. */
      if (p && typeof p.then === 'function') {
        p.then(function () {
          card.classList.add('is-playing');
          syncCtrls(card);
        }).catch(function () {
          card.classList.remove('is-playing');
          syncCtrls(card);
        });
      } else {
        card.classList.add('is-playing');
        syncCtrls(card);
      }
    }

    function render(skipPlay) {
      for (var i = 0; i < n; i++) {
        var card = cards[i];
        var off = offsetOf(i);
        var abs = Math.abs(off);

        /* A wrapping card jumps the full width of the deck. With an even card count
           it goes straight from a visible outer slot to the opposite hidden one, and
           the transition would animate it back across the stage in full view. Cut
           the transition for that single commit, then restore it. */
        var prev = card._vcfOff;
        var jumped = prev !== undefined && Math.abs(off - prev) > 1;
        if (jumped) card.style.transition = 'none';
        card._vcfOff = off;

        card.style.setProperty('--off', off);
        card.setAttribute('data-tier', String(Math.min(abs, 2)));
        card.setAttribute('data-hidden', abs > 2 ? '1' : '0');
        card.style.zIndex = String(60 - abs);
        card.classList.toggle('is-center', abs === 0);

        var pick = card.querySelector('[data-vcf-pick]');
        if (pick) pick.tabIndex = abs > 2 ? -1 : 0;
        var ctrls = card.querySelectorAll('[data-vcf-play],[data-vcf-mute]');
        for (var c = 0; c < ctrls.length; c++) ctrls[c].tabIndex = abs > 2 ? -1 : 0;

        if (jumped) { void card.offsetWidth; card.style.transition = ''; }
      }
      for (var d = 0; d < dots.length; d++) {
        dots[d].setAttribute('aria-current', d === active ? 'true' : 'false');
      }
      pauseAllExcept(videoOf(cards[active]));
      if (!skipPlay) playCenter();
    }

    function go(i) {
      active = loop ? ((i % n) + n) % n : Math.max(0, Math.min(n - 1, i));
      render();
    }

    /* wiring ------------------------------------------------------------- */
    cards.forEach(function (card, i) {
      var pick = card.querySelector('[data-vcf-pick]');
      if (pick) pick.addEventListener('click', function () { go(i); });

      var pb = card.querySelector('[data-vcf-play]');
      if (pb) pb.addEventListener('click', function () {
        if (i !== active) { go(i); return; }
        var v = videoOf(card);
        if (!v) return;
        if (card.classList.contains('is-playing')) {
          v.pause();
          card.classList.remove('is-playing');
        } else {
          pauseAllExcept(v);
          v.play().then(function () {
            card.classList.add('is-playing');
            syncCtrls(card);
          }).catch(function () {});
        }
        syncCtrls(card);
      });

      var mb = card.querySelector('[data-vcf-mute]');
      if (mb) mb.addEventListener('click', function () {
        if (i !== active) { go(i); return; }
        var v = videoOf(card);
        if (!v) return;
        var on = !card.classList.contains('is-unmuted');
        v.muted = !on;
        card.classList.toggle('is-unmuted', on);
        /* unmuting is a clear intent to watch — start it if it is not running */
        if (on && v.paused) {
          v.play().then(function () {
            card.classList.add('is-playing');
            syncCtrls(card);
          }).catch(function () {});
        }
        syncCtrls(card);
      });
    });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        go(parseInt(dot.dataset.vcfIndex, 10) || 0);
      });
    });

    var prevBtn = root.querySelector('[data-vcf-prev]');
    var nextBtn = root.querySelector('[data-vcf-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { go(active - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(active + 1); });

    stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(active - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); go(active + 1); }
    });

    /* pointer swipe */
    var startX = null;
    stage.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      startX = e.clientX;
    });
    stage.addEventListener('pointerup', function (e) {
      if (startX === null) return;
      var dx = e.clientX - startX;
      startX = null;
      if (Math.abs(dx) < 40) return;
      /* physical direction, mirrored under RTL */
      var rtl = getComputedStyle(root).direction === 'rtl';
      var forward = rtl ? dx > 0 : dx < 0;
      go(active + (forward ? 1 : -1));
    });
    stage.addEventListener('pointercancel', function () { startX = null; });

    /* pause off-screen so a deck below the fold never plays to nobody */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) playCenter();
          else pauseAllExcept(null);
        }
      }, { threshold: 0.25 });
      io.observe(stage);
      root._vcfIO = io;
    }

    if (RM && RM.addEventListener) {
      RM.addEventListener('change', function () {
        if (reduced()) pauseAllExcept(null);
        else playCenter();
      });
    }

    /* server-rendered state is already correct, so the first paint must not be
       re-committed — only wire the runtime state up to it */
    render(true);
    root._vcfPauseAll = function () { pauseAllExcept(null); };
    root._vcfPlay = playCenter;
  }

  function bootstrap(scope) {
    var els = (scope || document).querySelectorAll('[data-modulo-vcf]');
    for (var i = 0; i < els.length; i++) initSection(els[i]);
  }

  /* An identical <script src> still executes once per tag, so document-level
     listeners have to be wired exactly once. */
  if (!window.moduloVcfWired) {
    window.moduloVcfWired = true;

    document.addEventListener('visibilitychange', function () {
      var els = document.querySelectorAll('[data-modulo-vcf]');
      for (var i = 0; i < els.length; i++) {
        if (document.hidden) { if (els[i]._vcfPauseAll) els[i]._vcfPauseAll(); }
        else if (els[i]._vcfPlay) els[i]._vcfPlay();
      }
    });

    /* theme editor re-render */
    document.addEventListener('shopify:section:load', function (e) {
      bootstrap(e.target);
    });
    document.addEventListener('shopify:section:unload', function (e) {
      var els = e.target.querySelectorAll('[data-modulo-vcf]');
      for (var i = 0; i < els.length; i++) {
        if (els[i]._vcfIO) els[i]._vcfIO.disconnect();
        if (els[i]._vcfPauseAll) els[i]._vcfPauseAll();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bootstrap(); });
  } else {
    bootstrap();
  }
})();
